export const getMaterialUsageByName = (name: string) => {
  const materialUsageMap = {
    config_ral_primary: 'primary',
    config_ral_secondary: 'secondary',
  };
  return materialUsageMap[name];
};
